import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';

const BASIC_MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];
const DIRECTIVES_MODULE = [DirectivesModule];
const PIPES_MODULE = [PipesModule];

@NgModule({
  declarations: [
    
  ],
  imports: [
    ...
    BASIC_MODULES,
    DIRECTIVES_MODULE,
    PIPES_MODULE

  ],
  exports: [
    ...
    BASIC_MODULES,
    DIRECTIVES_MODULE,
    PIPES_MODULE
  ]
})
export class InitAngularModule { }
